import fetch from "isomorphic-fetch";
import _ from "lodash";
import {
	API2_URL,REVISION_REQUEST, REVISION_EXPENSES, REVISION_REGISTRY, REVISION_PROFILES, REVISION_OWNER,
	REVISION_INSTANCE, REVISION_FAIL, REVISION_CONCLUSION, REVISION_CONCLUSION_EDIT, REVISION_AGREEMENTS_ADMIN,
	REVISION_AGREEMENTS_ADMIN_EDIT, REVISION_AGREEMENTS_LEGAL, REVISION_AGREEMENTS_LEGAL_EDIT, REVISION_REPORTS_FINANCIAL,
	REVISION_REPORTS_EXPENSES, REVISION_REPORTS_SUMMARY, REVISION_CLEAR, REVISION_COMMISSION,
	REVISION_COMMISSION_CLEAR, REVISION_COMPLETE
} from "../store/config";
import {newNotification} from "./notifications";
import { sessionService } from 'redux-react-session';
import {entitiesList} from "./entities";
import {modalitiesList} from "./modalities";
import {resourceConceptsList} from "./resource_concept";
import {projectOwner, fetchProjectAgency, fetchCompletProject, projectClear} from "./project";
import {reportsFinancial, reportsSummary} from "./reports";

export const fetchRevision = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};
			dispatch(requestRevision());
			dispatch(revisionClear());
			return fetch(`${API2_URL}/revisions/${modality}/${state}${mun !== undefined ? '/'+mun : ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			//return fetch(`${API2_URL}/revisions/${modality}/${state}${mun !== undefined ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(revisionOwner(json));
						dispatch(revisionInstance(json));
						dispatch(revisionRegistry(json));
						dispatch(revisionExpenses(json));
						dispatch(revisionProfiles(json));
						dispatch(revisionConclusion(json));
						dispatch(revisionAgreementsAdmin(json));
						dispatch(revisionAgreementsLegal(json));
						dispatch(revisionComplete());
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const fetchRevisionLegal = (modality, state, mun = undefined) => (dispatch) => {
	dispatch(requestRevision());
	dispatch(revisionClear());
	dispatch(projectClear());
	dispatch(entitiesList());

	return dispatch(fetchRevisionOwner(modality, state, mun))
		.then(revOwner => {
			if(!_.isEmpty(revOwner.payload)){
				return dispatch(projectOwner(modality, state, mun))
					.then(owner => {
						if(!_.isEmpty(owner.payload)){
							return dispatch(fetchRevisionInstance(modality, state, mun))
								.then(revInstance => {
									if(!_.isEmpty(revInstance.payload)){
										return dispatch(fetchProjectAgency(modality, state, mun))
											.then(instance => {
												if(!_.isEmpty(instance.payload)){
													return dispatch(modalitiesList())
														.then(mods => {
															if(!_.isEmpty(mods.payload)){
																return dispatch(revisionComplete());
															}else {
																return dispatch(failedRevision('Carga incompleta'));
															}
														})
												}else {
													return dispatch(failedRevision('Carga incompleta'));
												}
											})
									}
								})
						}else {
							return dispatch(failedRevision('Carga incompleta'));
						}
					})
			}
		})
}

const fetchRevisionOwner = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};
			//return fetch(`${API2_URL}/revisions/project/register/legal/project-owner/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/register/legal/project-owner/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionOwner(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const fetchRevisionInstance = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get',
			};

			//return fetch(`${API2_URL}/revisions/project/register/legal/project-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/register/legal/project-agency/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionInstance(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const saveLegalRevision = (modality, state, mun = undefined, values) => (dispatch) => {
	let ownerSave = values.owner;let instanceSave = values.instance;
	dispatch(requestRevision());
	return dispatch(saveRevisionOwner(modality, state, mun, ownerSave))
		.then((owner) => {
			if(!_.isEmpty(owner.payload)){
				return dispatch(saveRevisionInstance(modality, state, mun, instanceSave))
					.then((instance) => {
						if(!_.isEmpty(instance.payload)){
							return dispatch(revisionComplete())
						}
					})
			}
		})
}

const saveRevisionOwner = (modality, state, mun = undefined, values) => (dispatch) =>{
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
				body: JSON.stringify({body: JSON.stringify(values.body)})
			};

			//dispatch(requestRevision());
			//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
			return fetch(`${API2_URL}/revisions/project/register/legal/project-owner/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionOwner(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const saveRevisionInstance = (modality, state, mun = undefined, values) => (dispatch) =>{
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id: values.status_id})
				body: JSON.stringify({notification_type_id: values.notification_type_id,body: JSON.stringify(values.body)})
			};

			return fetch(`${API2_URL}/revisions/project/register/legal/project-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionInstance(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const fetchRevisionProject = (modality, state, mun = undefined) => (dispatch) => {
	dispatch(requestRevision());
	dispatch(revisionClear());

	return dispatch(fetchRevisionRegistry(modality, state, mun))
		.then(registry => {
			if(!_.isEmpty(registry.payload)){
				return dispatch(fetchRevisionExpenses(modality, state, mun))
					.then(expenses => {
						if(!_.isEmpty(expenses.payload)){
							return dispatch(fetchRevisionProfiles(modality, state, mun))
								.then(profiles => {
									if(!_.isEmpty(profiles.payload)){
										return dispatch(fetchRevisionConclusion(modality, state, mun))
											.then(summary => {
												if(!_.isEmpty(summary.payload)){
													return dispatch(fetchCompletProject(modality, state, mun))
														.then(project => {
															if(!_.isEmpty(project.payload)){
																return dispatch(resourceConceptsList())
																	.then(concepts => {
																		if(!_.isEmpty(concepts.payload)){
																			return dispatch(fetchShowCommission(modality, state, mun));
																		}else {
																			return dispatch(failedRevision('Carga incompleta'));
																		}
																	})
															}else {
																return dispatch(failedRevision('Carga incompleta'));
															}
														})
												}
											})
									}
								})
						}
					})
			}
		})
}

const fetchRevisionRegistry = (modality, state, mun = undefined) => (dispatch) =>{
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			//return fetch(`${API2_URL}/revisions/project/register/project/project-goals/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/register/project/project-goals/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionRegistry(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const fetchRevisionExpenses = (modality, state, mun = undefined) => (dispatch) =>{
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			//return fetch(`${API2_URL}/revisions/project/register/project/project-expenses/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/register/project/project-expenses/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionExpenses(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const fetchRevisionProfiles = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			//return fetch(`${API2_URL}/revisions/project/register/project/project-profiles/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/register/project/project-profiles/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionProfiles(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const fetchRevisionConclusion = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			//return fetch(`${API2_URL}/revisions/project/register/project/project-conclusion/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/register/project/project-conclusion/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionConclusion(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const saveProjectRevision = (modality, state, mun = null, values) => (dispatch) => {
	let registrySave = values.registry; let profilesSave = values.profiles;
	let expensesSave = values.expenses; let conclusionSave = values.conclusion;

	dispatch(requestRevision());
	return dispatch(saveRevisionRegistry(modality, state, mun ? mun : null, registrySave))
		.then((registry) => {
			if(!_.isEmpty(registry.payload)){
				return dispatch(saveRevisionExpenses(modality, state, mun ? mun : null, expensesSave))
					.then((expenses) => {
						if(!_.isEmpty(expenses.payload)){
							return dispatch(saveRevisionProfiles(modality, state, mun ? mun : null, profilesSave))
								.then((profiles) => {
									if(!_.isEmpty(profiles.payload)){
										return dispatch(saveRevisionConclusion(modality, state, mun ? mun : null, conclusionSave))
											.then((conclusion) => {
												if(!_.isEmpty(conclusion.payload)){
													return dispatch(revisionComplete())
												}
											})
									}
								})
						}
					})
			}
		})
}

const saveRevisionRegistry = (modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
				body: JSON.stringify({body: JSON.stringify(values.body)})
			};

			//dispatch(requestRevision());
			//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
			return fetch(`${API2_URL}/revisions/project/register/project/project-goals/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionRegistry(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const saveRevisionExpenses = (modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
				body: JSON.stringify({body: JSON.stringify(values.body)})
			};

			//dispatch(requestRevision());
			return fetch(`${API2_URL}/revisions/project/register/project/project-expenses/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionExpenses(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const saveRevisionProfiles = (modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id:values.status_id})
				body: JSON.stringify({body: JSON.stringify(values.body)})
			};

			//dispatch(requestRevision());
			return fetch(`${API2_URL}/revisions/project/register/project/project-profiles/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));;
						return dispatch(revisionProfiles(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const saveRevisionConclusion = (modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({notification_type_id: values.notification_type_id, body: JSON.stringify(values.body)})
			};

			//dispatch(requestRevision());
			return fetch(`${API2_URL}/revisions/project/register/project/project-conclusion/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: 'La revisión se guardó correctamente', type: "success"}));;
						return dispatch(revisionConclusion(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const fetchRevisionAgreements = (type , modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {

			dispatch(requestRevision());
			dispatch(revisionClear());

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/revisions/project/agreements/${type}/project-agreements-agency/${modality}/${state}${mun !== undefined ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						if (type === 'admin'){
							return dispatch(revisionAgreementsAdmin(json));
						}else {
							return dispatch(revisionAgreementsLegal(json));
						}
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const saveAgreements = (type, modality, state, mun = undefined, values) => (dispatch) =>{
	let agreementsSave = {};
	if(type==='admin'){
		agreementsSave = values.agreements.admin
	}else {
		agreementsSave = values.agreements.legal
	}

	/*if(type==='administrativo'){
		dispatch(saveRevisionAgreementsAdmin(modality, state, mun, agreementsSave))
	}else {
		dispatch(saveRevisionAgreementsLegal(modality, state, mun, agreementsSave))
	}*/

	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(requestRevision());

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({body: JSON.stringify(agreementsSave.body), notification_type_id: agreementsSave.notification_type_id})
			};

			return fetch(`${API2_URL}/revisions/project/agreements/${type}/project-agreements-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						if (type === 'admin'){
							return dispatch(revisionAgreementsAdmin(json));
						}else {
							return dispatch(revisionAgreementsLegal(json));
						}
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

/*const saveRevisionAgreementsAdmin = (modality, state, mun = null, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id: values.status_id , notification_type_id: values.notification_type_id})
				body: JSON.stringify({body: JSON.stringify(values.body), notification_type_id: values.notification_type_id})
			};

			dispatch(requestRevision());
			//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
			return fetch(`${API2_URL}/revisions/project/agreements/admin/project-agreements-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionAgreementsAdmin(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const saveRevisionAgreementsLegal = (modality, state, mun = null, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				//body: JSON.stringify({id:values.id, body: JSON.stringify(values.body), phase_slug: values.phase_slug, status_id: values.status_id, notification_type_id: values.notification_type_id})
				body: JSON.stringify({body: JSON.stringify(values.body), notification_type_id: values.notification_type_id})
			};

			dispatch(requestRevision());
			//return fetch(`${API_URL}/revisions/${modality}/${state}${mun ? '/'+ mun : ''}/revision${values.id ? '/'+values.id+'?_method=PUT' : ''}`, options)
			//return fetch(`${API2_URL}/revisions/project/register/legal/project-agency-fiscal-entity-legal/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/agreements/legal/project-agreements-agency/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionAgreementsLegal(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}*/

export const fetchRevisionReports = (slug, modality, state, mun = undefined) => (dispatch) => {
	dispatch(requestRevision());
	dispatch(revisionClear());

	return dispatch(reportsSummary(modality, state, mun))
		.then((summary) => {
			if(!_.isEmpty(summary.payload)){
				switch (slug) {
					case 'project-report-goals':
						return dispatch(reportsFinancial(modality, state, mun))
							.then((financial) => {
								if(!_.isEmpty(financial.payload)){
									if(modality === 'modalidad-ii'){
										dispatch(entitiesList())
										return dispatch(revisionReports(slug, modality, state, mun))
									}else {
										return dispatch(revisionReports(slug, modality, state, mun))
									}
								}else {
									return dispatch(failedRevision('Carga Incompleta'));
								}
							})
					case 'project-report-expenses':
						if(modality === 'modalidad-ii'){
							dispatch(entitiesList())
							return dispatch(revisionReports(slug, modality, state, mun))
						}else {
							return dispatch(revisionReports(slug, modality, state, mun))
						}
					default:
						if(modality === 'modalidad-ii'){
							dispatch(entitiesList())
							return dispatch(revisionReports(slug, modality, state, mun))
						}else {
							return dispatch(revisionReports(slug, modality, state, mun))
						}
				}
			}else {
				return dispatch(failedRevision('Carga Incompleta'));
			}
		})
}

const revisionReports = (slug, modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			//dispatch(requestRevision());
			//dispatch(revisionClear());

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};
			//return fetch(`${API2_URL}/revisions/${modality}/${state}${mun !== undefined ? '/'+mun : ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			return fetch(`${API2_URL}/revisions/project/report/${slug}/${modality}/${state}${mun !== undefined ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						switch (slug) {
							case 'project-report-goals':
								return dispatch(revisionReportsFinancial(json));
							case 'project-report-expenses':
								return dispatch(revisionReportsExpenses(json));
							default:
								return dispatch(revisionReportsSummary(json));
						}
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const saveRevisionReportsFinancial = (modality, state, mun = null, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(requestRevision());

			let financialSave = values.reports.financial;

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({notification_type_id: financialSave.notification_type_id, body: JSON.stringify(financialSave.body)})
			};

			return fetch(`${API2_URL}/revisions/project/report/project-report-goals/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			//return fetch(`${API2_URL}/revisions/project/report/project-report-goals/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionReportsFinancial(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const saveRevisionReportsExpenses = (modality, state, mun = null, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(requestRevision());
			let expensesSave = values.reports.expenses;

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({notification_type_id: expensesSave.notification_type_id, body: JSON.stringify(expensesSave.body)})
			};

			return fetch(`${API2_URL}/revisions/project/report/project-report-expenses/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
			//return fetch(`${API2_URL}/revisions/project/report/project-report-expenses/${modality}/${state}${mun ? `/${mun}`: ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionReportsExpenses(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const saveRevisionReportsSummary = (modality, state, mun = null, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(requestRevision());
			let summarySave = values.reports.summary;

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({notification_type_id: summarySave.notification_type_id, body: JSON.stringify(summarySave.body)})
			};

			return fetch(`${API2_URL}/revisions/project/report/project-report-summary/${modality}/${state}${mun ? `/${mun}`: ''}?include[0]=version_phase.phase.phase_group&include[1]=notification_type&include[2]=project_version_phase.version_phase.phase`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'La revisión se guardó correctamente', type: "success"}));
						return dispatch(revisionReportsSummary(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const revisionOwner = (json) => {
	let phase = 'project-owner';let owner = undefined;

	if(_.isArray(json.data)){
		owner = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});
	}else {
		owner = json.data;
	}

	return {
		type: REVISION_OWNER,
		payload: _.isEmpty(owner) ? {body: undefined, phase_slug: phase} : {...owner, body: JSON.parse(owner.body), phase_slug: phase},
		phase_group: json.phase_group,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionInstance = (json) => {
	let phase = 'project-agency';let instance = undefined;

	if(_.isArray(json.data)){
		instance = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});
	}else {
		instance = json.data;
	}

	return {
		type: REVISION_INSTANCE,
		payload: _.isEmpty(instance) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : {...instance, body: JSON.parse(instance.body), phase_slug: phase},
		phase_group: json.phase_group,
		notifications_types: json.notifications_types,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionRegistry = (json) => {
	let phase = 'project-goals';let registry = undefined;

	if(_.isArray(json.data)){
		registry = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});
	}else {
		registry = json.data;
	}

	return {
		type: REVISION_REGISTRY,
		payload: _.isEmpty(registry) ? {body: undefined, phase_slug: phase} : {...registry, body: JSON.parse(registry.body), phase_slug: phase},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionExpenses = (json) => {
	let phase = 'project-expenses';let expenses = undefined;

	if(_.isArray(json.data)){
		expenses = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});
	}else {
		expenses = json.data;
	}

	return {
		type: REVISION_EXPENSES,
		payload: _.isEmpty(expenses) ? {body: undefined, phase_slug: phase} : {...expenses, body: JSON.parse(expenses.body), phase_slug: phase},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionProfiles = (json) => {
	let phase = 'project-profiles';let profiles = undefined;

	if(_.isArray(json.data)){
		profiles = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});
	}else {
		profiles = json.data;
	}

	return {
		type: REVISION_PROFILES,
		payload: _.isEmpty(profiles) ? {body: undefined, phase_slug: phase} : {...profiles, body: JSON.parse(profiles.body), phase_slug: phase},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionConclusion = (json) => {
	let phase = 'project-conclusion';let conclusion = undefined;

	if(_.isArray(json.data)){
		conclusion = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});

		return {
			type: REVISION_CONCLUSION,
			payload: _.isEmpty(conclusion) ? {notification_type_id: undefined,body: undefined, phase_slug: phase} : {...conclusion, body: JSON.parse(conclusion.body), phase_slug: phase},
			phase_group: json.phase_group,
			notifications_types: json.notifications_types,
			permissions: json.permissions,
			timestamp: Date.now()
		}

	}else {
		conclusion = json.data;

		return {
			type: REVISION_CONCLUSION_EDIT,
			payload: _.isEmpty(conclusion) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : {...conclusion, body: JSON.parse(conclusion.body), phase_slug: phase},
			phase_group: json.phase_group,
			notifications_types: json.notifications_types,
			permissions: json.permissions,
			timestamp: Date.now()
		}
	}
}

const revisionAgreementsAdmin = (json) => {
	//let phase = 'project-agency-fiscal-entity-admin';
	let phase = 'project-agreements-agency';

	let agreements = undefined;

	if(_.isArray(json.data)){
		agreements = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});
		//console.log('agreements===>', agreements);
		return {
			type: REVISION_AGREEMENTS_ADMIN,
			isFetching: false,
			payload: _.isEmpty(agreements) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : {...agreements, body: JSON.parse(agreements.body), phase_slug: phase},
			phase_group: json.phase_group,
			notifications_types: json.notifications_types,
			permissions: json.permissions,
			timestamp: Date.now()
		}
	}else {
		agreements = json.data;
		return {
			type: REVISION_AGREEMENTS_ADMIN_EDIT,
			isFetching: false,
			payload: _.isEmpty(agreements) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : {...agreements, body: JSON.parse(agreements.body), phase_slug: phase},
			phase_group: json.phase_group,
			permissions: json.permissions,
			timestamp: Date.now()
		}
	}
}

const revisionAgreementsLegal = (json) => {
	let phase = 'project-agency-fiscal-entity-legal';

	let agreements = undefined;

	if(_.isArray(json.data)){
		agreements = _.find(json.data,{project_version_phase:{version_phase:{phase: {slug: phase}}}});
		return {
			type: REVISION_AGREEMENTS_LEGAL,
			isFetching: false,
			payload: _.isEmpty(agreements) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : {...agreements, body: JSON.parse(agreements.body), phase_slug: phase},
			phase_group: json.phase_group,
			notifications_types: json.notifications_types,
			permissions: json.permissions,
			timestamp: Date.now()
		}
	}else {
		agreements = json.data;
		return {
			type: REVISION_AGREEMENTS_LEGAL_EDIT,
			isFetching: false,
			payload: _.isEmpty(agreements) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : {...agreements, body: JSON.parse(agreements.body), phase_slug: phase},
			phase_group: json.phase_group,
			permissions: json.permissions,
			timestamp: Date.now()
		}
	}
}

const revisionReportsFinancial = (json) => {
	let phase = 'project-report-goals';

	let financial = json.data;
	return {
		type: REVISION_REPORTS_FINANCIAL,
		isFetching: false,
		payload: _.isEmpty(financial) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : {...financial, body: JSON.parse(financial.body), phase_slug: phase},
		phase_group: json.phase_group,
		notifications_types: json.notifications_types,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionReportsExpenses = (json) => {
	let phase = 'project-report-expenses';

	let expenses = undefined;

	expenses = json.data;
	return {
		type: REVISION_REPORTS_EXPENSES,
		isFetching: false,
		payload: _.isEmpty(expenses) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : { ...expenses, body: JSON.parse(expenses.body), phase_slug: phase},
		phase_group: json.phase_group,
		notifications_types: json.notifications_types,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionReportsSummary = (json) => {
	let phase = 'project-report-summary';

	let summary = undefined;

	summary = json.data;
	return {
		type: REVISION_REPORTS_SUMMARY,
		isFetching: false,
		payload: _.isEmpty(summary) ? {notification_type_id: undefined, body: undefined, phase_slug: phase} : { ...summary, body: JSON.parse(summary.body), phase_slug: phase},
		phase_group: json.phase_group,
		notifications_types: json.notifications_types,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const failedRevision = (error) => {
	return {
		type: REVISION_FAIL,
		isFetching: false,
		error: error
	}
}

const requestRevision = () => {
	return {
		type: REVISION_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const revisionClear = () => {
	return {
		type: REVISION_CLEAR,
		payload: {
			owner: {
				body: undefined,
				phase_slug: undefined
			},
			instance: {
				body: [],
				phase_slug: undefined,
				notification_type_id: undefined
			},
			registry: {
				body: {},
				phase_slug: undefined
			},
			expenses: {
				body: {},
				phase_slug: undefined
			},
			profiles: {
				body: {},
				phase_slug: undefined
			},
			conclusion: {
				body: {},
				phase_slug: undefined,
				notification_type_id: undefined
			},
			commission: {
				spvpu: {},
				projects: {},
				project: {},
				answers: [],
				finished: false,
				comments: undefined,
				revision: undefined
			},
			agreements: {
				admin: {
					body: {},
					phase_slug: undefined,
					notification_type_id: undefined
				},
				legal: {
					body: {},
					phase_slug: undefined,
					notification_type_id: undefined
				}
			},
			reports:{
				financial:{
					notification_type_id: undefined,
					body: {},
					phase_slug: undefined,
					agency:[]
				},
				expenses:{
					notification_type_id: undefined,
					body: {},
					phase_slug: undefined,
					agency:[]
				},
				summary:{
					notification_type_id: undefined,
					body: {},
					phase_slug: undefined
				}
			},
			phase_group: {},
			notifications_types: [],
			permissions:[],
			surveyShow: false
		},
		timestamp: Date.now()
	}
}

const revisionComplete = () => {
	return {
		type: REVISION_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

/*Sección para comisiones*/
export const fetchCommission = () => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(requestRevision());
			dispatch(commisionsClear());
			return fetch(`${API2_URL}/revisions/commissions`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionCommission(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const fetchShowCommission = (modality, state, mun = null) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			//dispatch(commisionsClear());
			//dispatch(requestRevision());
			return fetch(`${API2_URL}/revisions/commissions/${modality}/${state}${mun !== null ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionDataCommission(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: _.values(error), type: "danger"}));
						return dispatch(failedRevision(_.values(error)));
					}
				)
		})
}

export const assignCommission = () => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post'
			};

			dispatch(requestRevision());
			dispatch(commisionsClear());
			return fetch(`${API2_URL}/revisions/commissions`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(revisionCommission(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const surveysSaveAnswer = (values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {

			/*let answers = [];
			_.map(values.answers,(item) => {
				if(item){
					return answers.push(item)
				}
			})*/

			let data = {};
			if(!_.isEmpty(values.answers)){
				if(values.finished){
					data = {
						answers: values.answers,
						finished: values.finished,
						comments: values.comments !== undefined ? values.comments:null
					};
				}else {
					data = {
						answers: values.answers,
						comments: values.comments !== undefined ? values.comments:null
					};
				}
			}

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(data)
			};

			dispatch(requestRevision());
			//return fetch((`${API_URL}/surveys/questions-answers`), options)
			return fetch((`${API2_URL}/revisions/commissions?_method=PUT`), options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La revisión se guardó correctamente", type: "success"}));
						return dispatch(revisionCommission(json))
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
						return dispatch(failedRevision(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
					}
				)
		})
}

const revisionCommission = (json) => {
	let answers = [];

	if(!_.isEmpty(json.data) && !_.isEmpty(json.data.spvpu) && !_.isEmpty(json.data.spvpu.survey_version_phase)){
		_.map(json.data.spvpu.survey_version_phase.survey.children_questions,(q,k) => {
			if(q.type === 'group'){
				_.map(q.children_questions,(item) => {
					if(item.answer){
						//let answer = _.find(q.answers,{question_id: q.id});
						answers.push({spvpu_id: item.answer.spvpu_id, question_id: item.answer.question_id, answer_number: item.answer.answer_number, answer_text: item.answer.answer_text})
					}
				})
			}else {
				if(q.answer){
					//let answer = _.find(q.answers,{question_id: q.id});
					answers.push({spvpu_id: q.answer.spvpu_id, question_id: q.answer.question_id, answer_number: q.answer.answer_number, answer_text: q.answer.answer_text})
				}
			}
		})
	}
	//console.log('answers===>',answers);

	return {
		type: REVISION_COMMISSION,
		isFetching: false,
		payload: {
			...json.data,
			answers,
			project: json.data && json.data.spvpu ? json.data.spvpu.project_version_phase.project:{},
			comments: json.data && json.data.spvpu && json.data.spvpu.comments ? json.data.spvpu.comments:undefined,
			revision: json.revision ? {
				...json.revision,
				body: JSON.parse(json.revision.body)
			}:{}
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const revisionDataCommission = (json) => {
	let answers = [];

	if(!_.isEmpty(json.data) && !_.isEmpty(json.data.survey_version_phase)){
		_.map(json.data.survey_version_phase.survey.children_questions,(q) => {
			if(q.type === 'group'){
				_.map(q.children_questions,(item) => {
					if(item.answer){
						//let answer = _.find(q.answers,{question_id: q.id});
						answers.push({spvpu_id: item.answer.spvpu_id, question_id: item.answer.question_id, answer_number: item.answer.answer_number, answer_text: item.answer.answer_text})
					}
				})
			}else {
				if(q.answer){
					//let answer = _.find(q.answers,{question_id: q.id});
					answers.push({spvpu_id: q.answer.spvpu_id, question_id: q.answer.question_id, answer_number: q.answer.answer_number, answer_text: q.answer.answer_text})
				}
			}
		})
	}
	//console.log('answers===>',answers);

	return {
		type: REVISION_COMMISSION,
		isFetching: false,
		payload: {
			spvpu: json.data,
			answers,
			project: json.data ? json.data.project_version_phase.project:{},
			comments: json.data && json.data.comments ? json.data.comments:undefined,
			revision: {}
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const commisionsClear = () => {
	return {
		type: REVISION_COMMISSION_CLEAR,
		isFetching: false,
		payload: {
			spvpu: {},
			projects: {},
			project: {},
			answers: [],
			finished: false,
			comments: undefined,
			revision: undefined
		},
		timestamp: Date.now()
	}
}



// WEBPACK FOOTER //
// ./src/actions/revision.js